import request from '@/utils/request'

export const getMenuList = () => request.get('/masterdata-api/menu/list')
